import { makeAutoObservable, toJS } from "mobx"
import Participation, { ParticipationProps } from "../models/Participation"
import { Person } from "../models/Person"

export default class ParticipationList {
  items: Participation[]

  constructor(participationProps: ParticipationProps[] = []) {
    makeAutoObservable(this, {}, { autoBind: true })

    this.items = participationProps.map((props) => new Participation(props))
  }

  addCopyOfPerson(person: Person) {
    const copy = new Participation({ person: toJS(person) })
    this.items.push(copy)
  }

  remove(info) {
    const idx = this.items.indexOf(info)
    this.items.splice(idx, 1)
  }
}
